/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createConfigurationsRepository = (options: RestApiOptions): Types.ConfigurationsRepository => ({
    async get(params, requestOptions) {
        return options.request('/configurations/get', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
